import React from 'react';
import Div from '../components/Div.styled';
import VWCelebrationMap from './vw-celebration-map';
import EventCounter from './event-counter';
import styled from 'styled-components';
import {GPSTourBrandExperiences} from '../constants';

const MapContainer = styled.div`
  height: 75vh;
  display: flex;
`;

const EventCounterContainer = styled.div`
  display: flex;
  justify-content: center;
`;

type VWCelebrationProps = {
  gpsTourBranch?: GPSTourBrandExperiences;
};

const VWCelebration: React.FC<VWCelebrationProps> = ({gpsTourBranch}) => {
  return (
    <Div>
      <MapContainer>
        <VWCelebrationMap gpsTourBranch={gpsTourBranch} />
      </MapContainer>
      <EventCounterContainer>
        <EventCounter gpsTourBranch={gpsTourBranch} />
      </EventCounterContainer>
    </Div>
  );
};

export default VWCelebration;
